<template>
    <div class="row col-12 vue-cart-type-radio"
         :class="{ 'no-default' : !selected, 'lock-cursor' : disableInput}"
         :tabindex="itemId"
         :id="elementId" ref="radioPicker">
        <h3 class="label-radio w-100"> {{ label }} </h3>
        <div
            v-for="(option, index) in options"
            :key="option.id"
            class="col-3 radio-thumb"
            :class="{'disabled-option': !option.stock, 'last-in-row': (index + 1) % 4 == 0}"
            :data-id="option.id"
            ref="radioItems"
            @click="getOptionObj(option)"
        >
            <div class="row mx-0 radio-content size-content">
                <label :for="option.id" class="size">
                    {{ option.description }}
                </label>
                <input
                    type="radio"
                    :id="option.id"
                    name="size"
                    :value="option.id"
                    :checked="selected == option"
                />
            </div>
        </div>
    </div>
</template>

<script>

import {storeCombos} from '@/store/comboCart';

export default {
    storeCombos,
    name: 'QuickRadio',
    components: {},
    props: {
        id: {
            type: String,
            default: 'radioPicker',
        },
        label: String,
        options: Array,
        value: Object,
        defaultValue: {
            type: Object,
            default: null,
        },
        disableInput: {
            type: Boolean,
            default: false,
        },
        comboCartMode: {
            type: Boolean,
            default: false,
        },
        currentSelection: String,
        itemId: { // for multiple widgets
            type: String,
            default: '0',
        },
        emptySelectionWarning: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            selected: this.defaultValue ? this.defaultValue : null,
            /*defaultClickFix: false,*/
        };
    },
    computed: {
        elementId() {
            return this.id + '-' + this.itemId; 
        },
        kStrings(){
            return storeCombos.getters.kStrings;
        },
    },
    methods: {
        getOptionObj: function(option, single = false) {
            this.selected = option;
            this.$emit('input', this.selected);
            if (!single) {
                this.$emit('update-cart-option', this.currentSelection);
            }
        },
    },
    watch: {
        defaultValue: {
            immediate: true,
            handler (value, oldVal) {
                if(!value && this.comboCartMode) {
                    this.selected = null;
                }
            }
        }
    },
    created() {
        this.$emit('input', this.value);
    },
    mounted() {
        if (this.defaultValue) {
            this.$emit('input', this.defaultValue);
        }

        if (this.options && this.options.length == 1) {
            this.getOptionObj(this.options[0], true);
        }
    },
};
</script>

<style lang="scss" scoped/>
